<div class="p-2 min-h-screen">
  <!-- Header -->
  <div class="flex items-center gap-2 mb-2">
    <h3 class="font-bold text-lg">{{ '::MyPerformance' | abpLocalization }}</h3>
  </div>

  <!-- Tabs de período -->
  <div class="flex justify-center bg-gray-100 rounded-xl p-1 w-full mb-4 overflow-x-auto">
    <button (click)="setPeriod('last30days')"
      [ngClass]="selectedPeriod === 'last30days' ? 'bg-white text-gray-900' : 'text-gray-500 hover:text-gray-700'"
      class="flex-1 py-1 text-sm font-medium rounded-lg transition whitespace-nowrap">
      {{ '::Last30Days' | abpLocalization }}
    </button>

    <button (click)="setPeriod('thisMonth')"
      [ngClass]="selectedPeriod === 'thisMonth' ? 'bg-white text-gray-900' : 'text-gray-500 hover:text-gray-700'"
      class="flex-1 py-1 text-sm font-medium rounded-lg transition whitespace-nowrap">
      {{ '::ThisMonth' | abpLocalization }}
    </button>

    <button (click)="setPeriod('thisYear')"
      [ngClass]="selectedPeriod === 'thisYear' ? 'bg-white text-gray-900' : 'text-gray-500 hover:text-gray-700'"
      class="flex-1 py-1 text-sm font-medium rounded-lg transition whitespace-nowrap">
      {{ '::ThisYear' | abpLocalization }}
    </button>
  </div>

  <!-- Tarjetas de KPI -->
  <div class="flex flex-col md:flex-row gap-2">
    <app-metro-kpi title="{{ '::Sales' | abpLocalization }}" [value]="kpiData.sales" format="number" [loading]="loading"
      [clickable]="true" (pressed)="onSalesCardClick()" class="w-full md:flex-1">
    </app-metro-kpi>

    <app-metro-kpi title="{{ '::MyClients' | abpLocalization }}" [value]="kpiData.clients" format="number"
      [loading]="loading" [clickable]="true" (pressed)="onClientsCardClick()" class="w-full md:flex-1">
    </app-metro-kpi>

    <app-metro-kpi *ngIf="hasPickupRole" title="{{ '::Deliveries' | abpLocalization }}" [value]="kpiData.deliveries"
      [clickable]="true" format="number" [loading]="loading" (pressed)="onDeliveriesCardClick()"
      class="w-full md:flex-1">
    </app-metro-kpi>
  </div>
</div>